import React from "react";

const DashboardHeader = ({ user }) => (
  <div className="dashboard-header">
    {/* <div className="user-info">
      <div className="user-avatar">{user.name?.charAt(0)?.toUpperCase()}</div>
      <div className="user-details">
        <h3>{user.name}</h3>
        <p>{user.email} • Admin</p>
      </div>
    </div> */}
    <h1 className="dashboard-title text-primary-foreground">Admin Dashboard</h1>
    <p className="dashboard-subtitle">Manage your training program and users</p>
  </div>
);

export default DashboardHeader;
